import React, { FC, memo } from "react";

import { SignInFooter } from "./Footer";

import {
  LogoContainer,
  LogoTextContainer,
  SignInLeftContainer,
  SignInLeftContent,
  SignInLeftDescription,
  SignInLeftTitle,
  SignInPageContainer,
  SignInRightContainer,
} from "./styled";

import { useLoginScreenSettings } from "../../hooks/useLoginScreenSettings";

const FormContainerComponent: FC = ({ children }) => {
  const { palette, hasContent, logo, logoText, title, description, backgroundImage, backgroundVideo, footer, overlay } =
    useLoginScreenSettings();

  return (
    <SignInPageContainer bgImg={backgroundImage} overlay={overlay} palette={palette}>
      {hasContent && (
        <SignInLeftContainer>
          <LogoContainer>
            {!!logo && <img src={logo} alt={title?.text || ""} />}
            {!!logoText?.text && (
              <LogoTextContainer
                fontColor={logoText?.fontColor}
                fontFamily={logoText?.fontFamily}
                dangerouslySetInnerHTML={{ __html: logoText?.text || "" }}
              />
            )}
          </LogoContainer>
          {(!!title?.text || !!description?.text) && (
            <SignInLeftContent>
              {!!title?.text && (
                <SignInLeftTitle
                  fontSize={title?.fontSize}
                  fontColor={title?.fontColor}
                  fontFamily={title?.fontFamily}
                  dangerouslySetInnerHTML={{ __html: title?.text || "" }}
                />
              )}
              {!!description?.text && (
                <SignInLeftDescription
                  fontColor={description?.fontColor}
                  fontFamily={description?.fontFamily}
                  dangerouslySetInnerHTML={{ __html: description?.text || "" }}
                />
              )}
            </SignInLeftContent>
          )}
          <SignInFooter {...footer} />
        </SignInLeftContainer>
      )}
      <SignInRightContainer>{children}</SignInRightContainer>
      {!!backgroundVideo && (
        <video className="background-video" autoPlay loop muted>
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}
      {!hasContent && <SignInFooter {...footer} />}
    </SignInPageContainer>
  );
};

export const FormContainer: FC = memo(FormContainerComponent);
